import React from 'react';
import { ChevronDown16Regular } from '@fluentui/react-icons';
import styles from '../css/vdr.module.css';

const ADD_OPTIONS = [
    { key: 'upload_files', label: 'Upload files' },
    { key: 'create_file', label: 'Create file' },
    { key: 'upload_folder', label: 'Upload folder' },
    { key: 'create_folder', label: 'Create folder' },
    { key: 'create_workstream', label: 'Create workstream' },
    { key: 'upload_recording', label: 'Upload meeting recording' },
];

const AddNewMenu = ({ onSelect, includeRecording = true }) => {
    const [open, setOpen] = React.useState(false);
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (!open) return undefined;
        const onDoc = e => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDoc);
        return () => document.removeEventListener('mousedown', onDoc);
    }, [open]);

    return (
        <div className={styles.addNewWrap} ref={ref}>
            <button type="button" className={styles.primaryBtn} onClick={() => setOpen(v => !v)}>
                + Add new <ChevronDown16Regular />
            </button>
            {open && (
                <div className={styles.menuPopover} role="menu">
                    {ADD_OPTIONS.filter(opt => includeRecording || opt.key !== 'upload_recording').map(opt => (
                        <button
                            key={opt.key}
                            type="button"
                            className={styles.menuItem}
                            role="menuitem"
                            onClick={() => {
                                setOpen(false);
                                onSelect?.(opt.key);
                            }}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AddNewMenu;
